// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePharmacyApi = class EdgePharmacyApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param PharmacyCardFinderRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pharmacyV1CardFinder(PharmacyCardFinderRequest, x_program_id) {
        const _url_ = '/edge/pharmacy/v1/CardFinder';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacyCardFinderRequest' is not null or undefined
        if (PharmacyCardFinderRequest === null || PharmacyCardFinderRequest === undefined) {
            throw new Error('Required parameter PharmacyCardFinderRequest was null or undefined when calling pharmacyV1CardFinder.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacyCardFinderRequest, "PharmacyCardFinderRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1CardFinderDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PharmacyCardFinderRequestSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pharmacyV1CardFinderRequestSearch(PharmacyCardFinderRequestSearchRequest, x_program_id) {
        const _url_ = '/edge/pharmacy/v1/CardFinderRequestSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacyCardFinderRequestSearchRequest' is not null or undefined
        if (PharmacyCardFinderRequestSearchRequest === null || PharmacyCardFinderRequestSearchRequest === undefined) {
            throw new Error('Required parameter PharmacyCardFinderRequestSearchRequest was null or undefined when calling pharmacyV1CardFinderRequestSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacyCardFinderRequestSearchRequest, "PharmacyCardFinderRequestSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1CardFinderRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PharmacyCardFinderResultSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pharmacyV1CardFinderResultSearch(PharmacyCardFinderResultSearchRequest, x_program_id) {
        const _url_ = '/edge/pharmacy/v1/CardFinderResultSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacyCardFinderResultSearchRequest' is not null or undefined
        if (PharmacyCardFinderResultSearchRequest === null || PharmacyCardFinderResultSearchRequest === undefined) {
            throw new Error('Required parameter PharmacyCardFinderResultSearchRequest was null or undefined when calling pharmacyV1CardFinderResultSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacyCardFinderResultSearchRequest, "PharmacyCardFinderResultSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1CardFinderResultSearchDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PharmacyBiRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pharmacyV1PharmacyBi(PharmacyBiRequest, x_program_id) {
        const _url_ = '/edge/pharmacy/v1/PharmacyBi';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacyBiRequest' is not null or undefined
        if (PharmacyBiRequest === null || PharmacyBiRequest === undefined) {
            throw new Error('Required parameter PharmacyBiRequest was null or undefined when calling pharmacyV1PharmacyBi.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacyBiRequest, "PharmacyBiRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyBiDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PharmacyBiRequestSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pharmacyV1PharmacyBiRequestSearch(PharmacyBiRequestSearchRequest, x_program_id) {
        const _url_ = '/edge/pharmacy/v1/PharmacyBiRequestSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacyBiRequestSearchRequest' is not null or undefined
        if (PharmacyBiRequestSearchRequest === null || PharmacyBiRequestSearchRequest === undefined) {
            throw new Error('Required parameter PharmacyBiRequestSearchRequest was null or undefined when calling pharmacyV1PharmacyBiRequestSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacyBiRequestSearchRequest, "PharmacyBiRequestSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyBiRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param PharmacyBiResultSearchRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async pharmacyV1PharmacyBiResultSearch(PharmacyBiResultSearchRequest, x_program_id) {
        const _url_ = '/edge/pharmacy/v1/PharmacyBiResultSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'PharmacyBiResultSearchRequest' is not null or undefined
        if (PharmacyBiResultSearchRequest === null || PharmacyBiResultSearchRequest === undefined) {
            throw new Error('Required parameter PharmacyBiResultSearchRequest was null or undefined when calling pharmacyV1PharmacyBiResultSearch.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(PharmacyBiResultSearchRequest, "PharmacyBiResultSearchRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PharmacyV1PharmacyBiResultSearchDefaultResponse");
        }
        return response;
    }
};
EdgePharmacyApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePharmacyApi);
export { EdgePharmacyApi };
//# sourceMappingURL=edgePharmacyApi.js.map